import React, { useEffect, useRef, useState } from 'react';

// const Browserling = require('./Browserling');
import { Form, Input, Button } from 'antd';
import { changeTitle } from '../../../../redux/actions/app';
import { useDispatch } from 'react-redux';
//import axios from 'axios';

function ValidationTool(props) {
  const iFrameWindow = useRef(null);
  const [browserlingToken, setBrowserlingToken] = useState('');
  const [siteToVisit, setSiteToVisit] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Validation Tool - Silent Push';
    dispatch(changeTitle('Validation Tool'));
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  useEffect(() => {
    setBrowserlingToken(props.browserlingToken);
  }, [props.browserlingToken]);

  const downHandler = ({ key }) => {
    // console.log('keyDown', key);
  };

  const upHandler = ({ key }) => {
    // console.log('keyUp', key);
    //console.log(iFrameWindow.current.contentWindow);
    // window.parent.postMessage({ action: 'keyUp', key });
    //const iFrameDomElement = ReactDOM.findDOMNode(this.refs.iFrameWindow);
    iFrameWindow.current.contentWindow.postMessage({
      action: 'keyPress',
      keyCode: 37,
    });
  };

  window.onload = function () {
    document.getElementsByTagName('iframe')[0].focus();
  };

  const focusOnIFrame = () => {
    document.getElementsByTagName('iframe')[0].focus();
  };

  const onFinish = (values) => {
    // console.log('Success:', values);

    props.getAccessTokenBrowserling({
      username: values?.username,
      password: values?.password,
    });
    setSiteToVisit(values?.site);
    document.getElementsByTagName('iframe')[0].focus();
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div onMouseOver={focusOnIFrame} style={{ marginTop: '50px' }}>
      <iframe
        title="myIframe"
        allow="clipboard-read; clipboard-write self https://app-dev.silentpush.com"
        name="myIframe"
        id={'myIframe'}
        frameBorder="0"
        ref={iFrameWindow}
        style={{ width: '1024px', height: '768px', background: '#FFF' }}
        src={
          'https://api.browserling.com/raw_browser?api_key=' +
          browserlingToken +
          '&browser=firefox&version=90&url=' +
          siteToVisit
        }
      ></iframe>
      <Form
        name="basic"
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 8,
        }}
        initialValues={{}}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Site to visit"
          name="site"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input
            width={300}
            placeholder="Enter site you would like to visit"
            //value={siteToVisit}
            //onChange={(e) => setSiteToVisit(e)}
          />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 4,
            span: 4,
          }}
        >
          <Button type="primary" htmlType="submit">
            Login
          </Button>
        </Form.Item>
      </Form>
      {/* <div id="#browserling" dangerouslySetInnerHTML={createMarkup()}></div> */}
      {/* <div id="#browserling">{createMarkup()}</div> */}
    </div>
  );
}

export default ValidationTool;
